import { useEffect } from 'react';

export function useCustomEventListener<T>(
  eventName: string,
  handler: (event: CustomEvent<T>) => void
) {
  useEffect(() => {
    const eventListener: EventListener = (event: Event) => {
      handler(event as CustomEvent<T>);
    };

    window.addEventListener(eventName, eventListener);

    return () => {
      window.removeEventListener(eventName, eventListener);
    };
  }, [eventName, handler]);
}
